import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import loadingOverlayReducer from './ui/loadingOverlaySlice'
import uiReducer from './ui/uiSlice'
import modalReducer from './ui/modal/modalSlice'

const createStore = () => {
  const thunkArguments = {}
  const store = configureStore({
    reducer: {
      ui: uiReducer,
      auth: authReducer,
      loadingOverlay: loadingOverlayReducer,
      modal: modalReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: thunkArguments,
        },
      }),
  })

  thunkArguments.store = store

  return store
}

const store = createStore()

export default store
